export default "__VITE_ASSET__B2IUnaem__"